import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';

import SelectApi from '../../common/SelectApi';
import { WidgetInOutProductProps } from '../Dashboard.types';

interface InOutProductFiltersProps {
 control: Control<WidgetInOutProductProps>;
 setValue: UseFormSetValue<WidgetInOutProductProps>;
 errors: FieldErrors<WidgetInOutProductProps>;
}

const InOutProductFilters: React.FC<InOutProductFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const productFilter = JSON.stringify({ fields: 'Id,Name' });
 const destPointFilter = JSON.stringify({ fields: 'Id,Name' });
 return (
  <>
   <SelectApi<WidgetInOutProductProps>
    name="products"
    url="/api/Products/v2/"
    filter={productFilter}
    label="Produktas"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <h3>Produktų grupės filtras</h3>
   <SelectApi<WidgetInOutProductProps>
    name="toDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label="Paskirties taškai (ToDestPoint)"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <h3>Paskirties taškų grupės filtras</h3>
   <h3>Padaliniai filtras</h3>
  </>
 );
};

export default InOutProductFilters;
